import React from 'react';

const IconOut = props =>
  <svg viewBox="0 0 22 22" width="22px" height="22px" {...props}>
    <path d="M10.097 7.257l-5.594 3.759l5.594 3.758V12.12h5.042V9.911h-5.042V7.257z" />
    <path d="M15.172 4.004h-6.44c-1.283 0-2.326 1.004-2.326 2.239v2.439L7.967 7.5V6.243c0-0.406 0.342-0.736 0.764-0.736 h6.44c0.422 0 0.764 0.33 0.764 0.736v5.153v4.36c0 0.406-0.342 0.735-0.764 0.735h-6.44c-0.422 0-0.764-0.329-0.764-0.735v-1.296 l-1.562-1.112v2.408c0 1.234 1.043 2.239 2.326 2.239h6.44c1.281 0 2.324-1.005 2.324-2.239V6.243 C17.496 5.008 16.453 4.004 15.172 4.004z" />
  </svg>;

export default IconOut;
